/**
 * The SSML Amazon Connect (through Polly) understands, as the quick-select
 * beside the announcement editor offers it. Each entry is the snippet
 * inserted at the cursor. Kept to the tags Connect's documentation lists
 * as supported in Play prompt and Get customer input blocks.
 */
export interface SsmlTag {
  tag: string;
  label: string;
  snippet: string;
  hint: string;
}

export const SSML_TAGS: SsmlTag[] = [
  { tag: "break", label: "Pause", snippet: '<break time="500ms"/>', hint: "A pause; time in ms or s, or strength none/x-weak/weak/medium/strong/x-strong." },
  { tag: "emphasis", label: "Emphasis", snippet: '<emphasis level="moderate">word</emphasis>', hint: "Say it with more stress: strong, moderate or reduced." },
  { tag: "prosody", label: "Rate / pitch / volume", snippet: '<prosody rate="slow" pitch="medium" volume="medium">text</prosody>', hint: "rate x-slow…x-fast or a percentage; pitch x-low…x-high; volume silent…x-loud." },
  { tag: "say-as", label: "Say as", snippet: '<say-as interpret-as="telephone">18005550100</say-as>', hint: "characters, spell-out, cardinal, ordinal, digits, fraction, unit, date, time, address, telephone, expletive." },
  { tag: "p", label: "Paragraph", snippet: "<p>sentence</p>", hint: "A paragraph, with a longer pause after it." },
  { tag: "s", label: "Sentence", snippet: "<s>sentence</s>", hint: "A sentence, with a short pause after it." },
  { tag: "sub", label: "Substitute", snippet: '<sub alias="Amazon Web Services">AWS</sub>', hint: "Say the alias instead of the text." },
  { tag: "phoneme", label: "Pronounce", snippet: '<phoneme alphabet="ipa" ph="pɪˈkɑːn">pecan</phoneme>', hint: "Phonetic pronunciation in IPA or X-SAMPA." },
  { tag: "lang", label: "Language", snippet: '<lang xml:lang="fr-FR">Bonjour</lang>', hint: "Say a word in another language." },
  { tag: "w", label: "Word role", snippet: '<w role="amazon:VB">read</w>', hint: "Which sense of a word: amazon:VB, amazon:VBD, amazon:NN, amazon:SENSE_1." },
  { tag: "amazon:effect", label: "Whisper / soft", snippet: '<amazon:effect name="whispered">text</amazon:effect>', hint: "whispered, or phonation=\"soft\"; standard voices only." },
  { tag: "amazon:domain", label: "News / conversational", snippet: '<amazon:domain name="conversational">text</amazon:domain>', hint: "A speaking style for the neural voices that support it (news, conversational)." },
];

export const isSsml = (text: string): boolean => /^\s*<speak[\s>]/.test(text);

/** Wraps in `<speak>` once; removing the wrapper leaves the inner text. */
export const toSsml = (text: string): string => (isSsml(text) ? text : `<speak>${text}</speak>`);
export const fromSsml = (text: string): string => text.replace(/^\s*<speak[^>]*>/, "").replace(/<\/speak>\s*$/, "");
